<div class="close-btn-outer">
  <button mat-mini-fab color="warn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>


  <div fxLayout="column">

    <div fxLayout="row wrap" fxLayoutAlign="space-between center">
      <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" fxFlex.gt-md="100">
        <!--    <div class="button-container"
          style="width: 100%; height: 80%; position: relative;display:inline-block;margin-top: -10px;">
          <button class="mylocation" type="button" mat-icon-button matSuffix (click)="showMyLocation()">
            <mat-icon style="color:#545454">my_location</mat-icon>
          </button>
          <img style="position: absolute;top: 0;bottom: 0;left: 0; right: 0;margin: auto;
                    z-index: 1100;" src="assets/icon/pin_map.png" />
          <agm-map [latitude]="maplocation?.lat" [longitude]="maplocation?.lng" [zoom]="12" (mapReady)="mapReady($event)"
            (centerChange)="centerChange($event)">
          </agm-map>
        </div>
 -->

        <!-- <agm-map [latitude]="location?.lat" [longitude]="location?.lng" [zoom]="18" (mapReady)="mapReady($event)"
          (centerChange)="centerChange($event)" [gestureHandling]="'greedy'">
          <button id="CurrentPos" style="
    background: white; margin-top: 9px;margin-left: 5px; margin-right: 5px;" mat-icon-button
            (click)="setCurrentLocation()">
            <mat-icon aria-label="label">gps_fixed</mat-icon>
          </button>

          <mat-form-field id="SearchCustom" class="width-form" appearance="outline">

            <input matInput type="text" [(ngModel)]="address" required [ngModelOptions]="{standalone: true}" type="text"
              (keydown.enter)="$event.preventDefault()" placeholder="Busca una dirección" autocorrect="off"
              autocapitalize="off" spellcheck="off" type="text" #search>
            <button color="primary" *ngIf="!loading" mat-icon-button matSuffix [attr.aria-pressed]="true"
              (click)="showLocation()">

              <mat-icon aria-label="" style="margin-top: -6px;">search</mat-icon>
            </button>
            <mat-spinner *ngIf="loading" matSuffix [diameter]="20"></mat-spinner>

          </mat-form-field>

          <agm-marker [latitude]="centerLocation?.lat" [longitude]="centerLocation?.lng" [markerDraggable]="false">
          </agm-marker>
        </agm-map> -->


        <!-- <google-map
          [center]="location"
          [zoom]="18"
          (mapClick)="mapClicked($event)">

          <map-marker
            [position]="location"
            [options]="{ draggable: true }"
            (mapDragEnd)="markerDragEnd($event)">
          </map-marker>

        </google-map> -->


        <google-map height="500px" width="100%" [center]="center" [zoom]="zoom">
          <map-marker [position]="center" [options]="markerOptions"></map-marker>
        </google-map>

      </div>
    </div>
  </div>

</div>
<mat-dialog-actions fxLayoutAlign="row">

  <!-- <button type="button" mat-raised-button (click)="dialogRef.close()">Cancelar</button> -->

  <div fxFlex="100">

    <div fxLayout="row" fxLayout.xs="column"
      class="d-flex justify-content-between align-items-start flex-row flex-xs-column text-muted">

      <div>
        <mat-checkbox [checked]="this.activeReplace" (change)="changeCheck($event)">
        </mat-checkbox> <span style="margin-left: 5px;"> Reemplazar con la dirección del mapa</span>
        <!--  <mat-form-field appearance="outline" class="w-100 px-1" style="margin-top: 5px;">

          <mat-label>Esta es la direccion que se guardará</mat-label>
          <input matInput id="addresIn" [(ngModel)]="dinamicAddress" placeholder="colonia, bloque, # de casa o apto."
            type="text" required #addresIn="ngModel">
          <mat-hint>Colonia, bloque, # de casa o apto.</mat-hint>
          <mat-error *ngIf="addresIn.invalid && addresIn.errors.required">Campo Requerido</mat-error>
        </mat-form-field> -->
      </div>

      <div>
        <div class="button-container">
          <div class="spinner-container" *ngIf="loadSave">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
          <!-- <button (click)="onSave()" type="submit" mat-raised-button color="primary">Guardar</button> -->
        </div>
      </div>
    </div>
  </div>
</mat-dialog-actions>
